import { useParams } from 'react-router-dom';
import { UUID } from '@/types';
import { GET_SAVED_QUERIES, usePrefetch } from '../apiSlice';

export const usePrefetchSavedQueries = () => {
  const { datasourceId } = useParams<{ datasourceId: UUID }>();
  const prefetchSavedQueries = usePrefetch(GET_SAVED_QUERIES, {
    ifOlderThan: 10,
  });

  return () => prefetchSavedQueries(datasourceId!);
};
